import { ActionTree, ActionContext } from 'vuex';

import { contextifyClient } from '@/http-client';
import { camelToSnake, snakeToCamel } from '@/utils';

import { RootStateI } from '../state';
import { ProjectI, ProjectsStateI } from './state';

export const actions: ActionTree<ProjectsStateI, RootStateI> = {
  async create(
    context: ActionContext<ProjectsStateI, RootStateI>,
    payload: ProjectI,
  ): Promise<void> {
    const { data } = await contextifyClient.post('/api/projects/create', camelToSnake(payload));
    const camelData = snakeToCamel(data);
    context.commit('setProject', camelData);
    console.log(data);
    return data;
  },

  async getProjectDetails(
    context: ActionContext<ProjectsStateI, RootStateI>,
    payload: string,
  ): Promise<void> {
    const { data } = await contextifyClient.get(`/api/projects/details/${payload}`);
    const camelData = snakeToCamel(data);
    context.commit('setProject', camelData);
    return data;
  },

  async addDocument(
    context: ActionContext<ProjectsStateI, RootStateI>,
    payload: {
      projectId: string;
      name: string;
      urls: string[];
    },
  ): Promise<void> {
    console.log('payload', payload);
    const { data } = await contextifyClient.post('/api/documents/add', camelToSnake(payload));
    console.log('data', data);
    await context.dispatch('filterDocuments', {
      projectId: payload.projectId,
      page: 1,
      limit: 100,
      q: '',
    });
    return data;
  },

  async addTextDocument(
    context: ActionContext<ProjectsStateI, RootStateI>,
    payload: {
      projectId: string;
      content: string;
    },
  ): Promise<void> {
    console.log('payload', payload);
    const { data } = await contextifyClient.post('/api/documents/add-text', camelToSnake(payload));
    console.log('data', data);
    await context.dispatch('filterDocuments', {
      projectId: payload.projectId,
      page: 1,
      limit: 100,
      q: '',
    });
    return data;
  },

  async filterDocuments(
    context: ActionContext<ProjectsStateI, RootStateI>,
    payload: {
      projectId: string;
      page: number;
      limit: number;
      q: string;
    },
  ): Promise<void> {
    const { data } = await contextifyClient.get(`/api/documents/filter?project_id=${payload.projectId}&page=${payload.page}&limit=${payload.limit}&q=${payload.q}`);
    console.log('data', data);
    context.commit('setDocuments', snakeToCamel(data));
    return data;
  },

  async list(
    context: ActionContext<ProjectsStateI, RootStateI>,
    payload: {
      q: string;
      page: number;
      limit: number;
    },
  ): Promise<void> {
    const { data } = await contextifyClient.get(`/api/projects/list?q=${payload.q}&page=${payload.page}&limit=${payload.limit}`);
    console.log(data);
    context.commit('setProjects', snakeToCamel(data));
    return data;
  },

  async removeDocument(
    context: ActionContext<ProjectsStateI, RootStateI>,
    payload: {
      projectId: string;
      documentId: string;
    },
  ): Promise<void> {
    const { data } = await contextifyClient.delete(`/api/documents/${payload.projectId}/${payload.documentId}`);
    console.log('data', data);
    await context.dispatch('filterDocuments', {
      projectId: payload.projectId,
      page: 1,
      limit: 100,
      q: '',
    });
    return data;
  },

  async removeProject(
    context: ActionContext<ProjectsStateI, RootStateI>,
    payload: {
      projectId: string;
      q: string;
      page: number;
      limit: number;
    },
  ): Promise<void> {
    const { data } = await contextifyClient.delete(`/api/projects/${payload.projectId}`);
    console.log('data', data);
    await context.dispatch('list', {
      q: payload.q,
      page: payload.page,
      limit: payload.limit,
    });
    return data;
  },

  async invite(
    context: ActionContext<ProjectsStateI, RootStateI>,
    payload: {
      projectId: string;
      email: string;
      role: string;
    },
  ): Promise<any> {
    const { data } = await contextifyClient.post(`/api/projects/${payload.projectId}/invite`, {
      email: payload.email,
      role: payload.role,
    });
    return data;
  },

  async acceptInvitation(
    context: ActionContext<ProjectsStateI, RootStateI>,
    payload: { token: string },
  ): Promise<any> {
    const { data } = await contextifyClient.post('/api/projects/invitations/accept', {
      token: payload.token,
    });
    return snakeToCamel(data);
  },

};
